import styled from "styled-components";

export const LoginStyled = styled.div`
.full-screen {
  display: flex;
  justify-content: center;
  height: calc(100vh - 75px);
  max-height: calc(100vh - 75px);
  font-family: Arial, sans-serif;
  max-width: 100%;
  margin: 0px;
}

.centered-text {
  background-color: white;
  padding: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 80%;
  text-align: center;
  border: 1px solid #ccc;
  height: 100%;
}


.centered-text h3 {
  margin-bottom: 20px;
  font-size: 24px;
  color: #333;
}

.form-group {
  margin-bottom: 20px;
  text-align: left;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #555;
}

.form-group input {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

button {
  width: 100%;
  padding: 10px 15px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
  background-color: #ff7218;
  color: white;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #ff7218;
}

`